import { privateFetch } from "../../utils/CustomFetch"
import { CONSTANT } from "../../utils/Constant"

// ========== ALERTAS ==========

export const getAlerts = async (userId, rolId, page, limit) => {
    try {
        const response = await privateFetch.get(
            `maintenance/lead-alert/user/${userId}/${rolId}/${page}/${limit}`,
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getUnreadCount = async (userId, rolId) => {
    try {
        const response = await privateFetch.get(
            `maintenance/lead-alert/user/${userId}/${rolId}/count`,
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const markAlertAsRead = async (alertId) => {
    try {
        const response = await privateFetch.put(
            `maintenance/lead-alert/${alertId}/read`,
            {},
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const markAllAsRead = async (userId, rolId) => {
    try {
        const response = await privateFetch.put(
            `maintenance/lead-alert/read-all/${userId}/${rolId}`,
            {},
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const dismissAlert = async (alertId) => {
    try {
        const response = await privateFetch.put(
            `maintenance/lead-alert/${alertId}/dismiss`,
            {},
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const generateAlerts = async () => {
    try {
        const response = await privateFetch.post(
            'maintenance/lead-alert/generate',
            {},
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const processNurtureCycles = async () => {
    try {
        const response = await privateFetch.post(
            'maintenance/lead-alert/process-nurture-cycles',
            {},
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// ========== REGLAS DE SEGUIMIENTO ==========

export const getRules = async (page, limit) => {
    try {
        const response = await privateFetch.get(
            `maintenance/follow-up-rule/${page}/${limit}`,
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getActiveRules = async () => {
    try {
        const response = await privateFetch.get(
            'maintenance/follow-up-rule/active',
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const saveRule = async (data) => {
    try {
        const response = await privateFetch.post(
            'maintenance/follow-up-rule',
            data,
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateRule = async (id, data) => {
    try {
        const response = await privateFetch.put(
            `maintenance/follow-up-rule/${id}`,
            data,
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteRule = async (id) => {
    try {
        const response = await privateFetch.delete(
            `maintenance/follow-up-rule/${id}`,
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};
